import React from 'react';
import { Link } from 'react-router-dom';

const Thumb = ({ ordernum, postImage, title, subtitle, avatarUrl, author, shortContent, likeCount, commentCount, timeStamp  }) => (
  <div className={ordernum === 1 ? 'flex-card is-post is-pulled-top light-bordered': 'flex-card is-post light-bordered'}>
      <div className="header has-background-image" style={{ backgroundImage: `url("${postImage}")` }}>
          <div className="title-wrapper">
              <h2 className="post-title">{title}</h2>
              <h4 className="post-subtitle">{subtitle}</h4>
          </div>
          <div className="author-avatar">
            <img src={avatarUrl} alt=""/>
          </div>
          <button className="like fab-btn mini">
              <span className="like-wrapper">
                          <i className="material-icons unliked">favorite_border</i>
                          <i className="material-icons liked">favorite</i>
                          <span className="like-overlay"></span>
              </span>
          </button>
          <div className="header-overlay"></div>
      </div>
      <div className="post-body">
          <div> <span>Hazırlayan</span> <a className="author-name" href="#"><b>{author}</b></a></div>
          <small>{timeStamp}</small>
          <p>{shortContent}</p>
          <div className="content-footer">
              <div className="footer-details">
                  <Link className="button is-link btn-upper" to="/BlogPost/12">Devamı</Link>
                  <div className="likes-count ml-auto">
                      <i className="im im-icon-Heart-2"></i>
                      <span className="stat">{likeCount}</span>
                  </div>
                  {
                    commentCount > 0
                      ? (
                        <div className="comments-count">
                            <i className="im im-icon-Speach-Bubble11"></i>
                            <span className="stat">{commentCount}</span>
                        </div>
                      )
                      : ''
                  }
              </div>
          </div>
      </div>
  </div>
);

export default Thumb;
